import { FormSpy } from "react-final-form";

function FormScrollError() {
  return (
    <FormSpy
      subscription={{ submitFailed: true }}
      onChange={() => {
        setTimeout(() => {
          const el = document.querySelector(".fieldError");

          if (el) {
            el.scrollIntoView({ behavior: "smooth" });
          }
        }, 0);
      }}
    />
  );
}

export default FormScrollError;
